import styled from 'styled-components';

export const OptionsGroupDivider = styled.div`
  height: 24px;
  display: flex;
  align-items: end;
  // riavviciniamo e spostiamo le checkbox
  // per averle come le label normali
  margin-bottom: -10px;
  &.vertical {
    margin-top: 8px;
  }
`;
